module.exports = __webpack_public_path__ + "img/paper_negative.4bb4e2a2.svg";